import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { ProgressBar } from 'components/ProgressBar';
import { getTrans } from 'modules/i18n';
import { getHoursAndMinutesLabel } from 'utils/date';
import { getCompletedPercentage, getProgressBarBaseColor } from '../utils';

interface Props {
  expectedMinutes: number;
  reportedMinutes: number;
  reportedReasonMinutes: number;
}

export const WorkedHoursProgressBar = ({
  expectedMinutes,
  reportedMinutes,
  reportedReasonMinutes
}: Props) => {
  const theme = useTheme();

  const {
    totalMinutes,
    completedPercentage,
    progressValueLabel,
    totalValueLabel,
    baseColor
  } = useMemo(() => {
    const totalMinutes = Math.max(expectedMinutes, reportedMinutes);
    const progressMinutes = Math.min(expectedMinutes, reportedMinutes);
    const completedPercentage = getCompletedPercentage(
      progressMinutes,
      totalMinutes
    );
    const progressValueLabel = getHoursAndMinutesLabel(reportedMinutes);
    const totalValueLabel = getHoursAndMinutesLabel(expectedMinutes);
    const baseColor = getProgressBarBaseColor(
      theme,
      expectedMinutes,
      reportedMinutes
    );

    return {
      totalMinutes,
      completedPercentage,
      progressValueLabel,
      totalValueLabel,
      baseColor
    };
  }, [theme, expectedMinutes, reportedMinutes]);

  const additionalPercentage = useMemo(
    () => getCompletedPercentage(Math.abs(reportedReasonMinutes), totalMinutes),
    [reportedReasonMinutes, totalMinutes]
  );

  return (
    <ProgressBar
      value={completedPercentage}
      bufferValue={additionalPercentage}
      baseColor={baseColor}
      progressLabel={getTrans('weekDetailsPage.progressBar.title1')}
      totalLabel={getTrans('weekDetailsPage.progressBar.title2')}
      progressValueLabel={progressValueLabel}
      totalValueLabel={totalValueLabel}
    />
  );
};
